import CalendarStripKeys from "./CalendarStrip/CalendarStrip.i18n";
import CollapsibleFareOptionKeys from "./CollapsibleFareOption/CollapsibleFareOption.i18n";
import CompanySelectionKeys from "./CompanySelection/CompanySelection.i18n";
import FareComparisonSelectorKeys from "./FareComparisonSelector/FareComparisonSelector.i18n";
import FareOptionKeys from "./FareOption/FareOption.i18n";
import FareOptionDetailsKeys from "./FareOptionDetails/FareOptionDetails.i18n";
import CarBookingFormKeys from "./forms/CarBookingForm/CarBookingForm.i18n";
import FlightBookingFormKeys from "./forms/FlightBookingForm/FlightBookingForm.i18n";
import RouteStationsFormFieldsKeys from "./forms/RouteStationsFormFields/RouteStationsFormFields.i18n";
import passengerSelectorKeys from "./PassengerSelector/PassengerSelector.i18n";
import CarBookingFormSchemaKeys from "./schema/carBookingFormSchema.i18n";
import flightBookingFormSchemaKeys from "./schema/flightBookingFormSchema.i18n";
import SwaBizToggleKeys from "./SwaBizToggle/SwaBizToggle.i18n";

export default {
  ...CalendarStripKeys,
  ...CarBookingFormKeys,
  ...CarBookingFormSchemaKeys,
  ...CollapsibleFareOptionKeys,
  ...CompanySelectionKeys,
  ...FareComparisonSelectorKeys,
  ...FareOptionDetailsKeys,
  ...FareOptionKeys,
  ...FlightBookingFormKeys,
  ...flightBookingFormSchemaKeys,
  ...passengerSelectorKeys,
  ...SwaBizToggleKeys,
  ...RouteStationsFormFieldsKeys,
};
